import { Text, View, Image } from "@react-pdf/renderer";
import styles from "./PdfStyles";

interface PdfFooterProps {
  disclaimer: string;
}

const PdfFooter: React.FC<PdfFooterProps> = ({ disclaimer }) => {
  return (
    <View
      fixed
      style={{
        position: "absolute",
        bottom: 35,
        left: 35,
        right: 35,
        textAlign: "center",
      }}
    >
      <View style={{ ...styles.row, marginTop: 6 }}>
        <Text style={{ ...styles.text, textAlign: "center" }}>
          {disclaimer}
        </Text>
      </View>
      <View style={styles.row}>
        <View style={styles.column}>
          <Image src="https://avid-boats.com/wp-content/uploads/2021/09/avid-boat-logo-black.jpg" />
        </View>
        <View style={styles.doubleColumn}>
          <Text style={{ ...styles.heading, fontFamily: "Oswald" }}>
            For Your Local Dealer Visit
          </Text>
          <Text style={{ ...styles.heading, fontSize: 12 }}>
            avid-boats.com/find-a-dealer/
          </Text>
        </View>
      </View>
    </View>
  );
};
export default PdfFooter;
